export function getAnonymousId(): string | null {
  if (typeof window === 'undefined') return null;

  try {
    // Single source of truth: keep ONLY `__anon_id` in localStorage.
    // (We previously also wrote `anon_id`, which created duplicates/confusion.)
    let id = window.localStorage.getItem('__anon_id');

    // Migration + cleanup:
    // - If legacy `anon_id` exists and `__anon_id` doesn't, adopt legacy.
    // - If both exist, keep `__anon_id` (source of truth) and remove legacy key.
    const legacy = window.localStorage.getItem('anon_id');
    if (!id && legacy) {
      id = legacy;
    }
    if (!id) {
      id =
        typeof window.crypto !== 'undefined' && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : `anon_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    }

    // Persist under the single canonical key.
    window.localStorage.setItem('__anon_id', id);
    // Always remove the legacy key so storage only has one anon id going forward.
    if (legacy !== null) {
      window.localStorage.removeItem('anon_id');
    }

    return id;
  } catch {
    // Storage blocked (Safari private / strict privacy)
    return null;
  }
}
